
import Konva from "konva"
import { useRef } from "react"
import { Rect as KonvaRect } from "react-konva"
import { Transform } from "../../../../geometry/transformation"

const RectBase = ({ shapeProps }: BaseShapeProps<RectShape>) => {
    const rectRef = useRef<Konva.Rect>(null)

    const rectTransform = new Transform(shapeProps.transformation);
    const rectOrigo = rectTransform.point2d(shapeProps);
    const rectProps = {
        ...shapeProps,
        x: rectOrigo.x,
        y: -rectOrigo.y,
        height: -shapeProps.height,
        id: shapeProps.id.toString(),
    }
    return (
        <KonvaRect {...rectProps} ref={rectRef} />)
}


export function createRectBase(s: GeometricShape) {
    return <RectBase shapeProps={s as RectShape} />
}
export default RectBase;